module.exports = require("@visa/vds-react/_stys/vds.min.css");